import { MdWorkOutline, MdOutlineCalendarMonth } from "react-icons/md";


export const historyConf = {
    "datetimeField": "created_at",
    "showInfo": [
        {
            "icon": <MdWorkOutline className="icon" />,
            "field": "entity"
        },
        {
            "icon": <MdOutlineCalendarMonth className="icon" />,
            "field": "period"
        }
    ]
};
